module.exports = __webpack_public_path__ + "assets/img/x5.6481c02e.png";